export const selectTab = (state: RootState) => state.programs.tabs.tab;
